// extracted by mini-css-extract-plugin
module.exports = {"avatar":"article-meta_avatar__ufGt3"};